import { proxy } from "valtio";

type StoreType = {
    isActionsClicked: boolean;
    isEdited: boolean;
    actions: Function;
    validationAction: any;
    isPlusIconClicked: boolean;
};

export const store = proxy<StoreType>({
    isActionsClicked: false,
    isEdited: false,
    actions: () => {},
    validationAction: {},
    isPlusIconClicked: false,
});

export function setIsEdited(isEdited: boolean): any {
    store.isEdited = isEdited;
}
export function setIsActionsClicked(isActionsClicked: boolean): any {
    store.isActionsClicked = isActionsClicked;
}
export function setValidationAction(validationAction: any): any {
    store.validationAction = validationAction;
}
export function setActions(actions: any): any {
    store.actions = actions;
}
export function setIsPlusIconClicked(isPlusIconClicked: boolean): void {
    store.isPlusIconClicked = isPlusIconClicked;
}

export default store;
